import { sendEvent, sendException } from 'helpers/analytics';
import { getChannelContextCode, getJsonStringify } from 'helpers/Utility';
import { setError, setHomePath } from 'store/actions/auth';
import { setEktpImg } from 'store/actions/loanApply';

const handleUnexpected = (
  dispatch,
  err,
  auth,
  errorKey = 'contact-cs',
  log = true
) => {
  dispatch(setError(errorKey));

  if (log) {
    sendEvent({
      category: 'Unexpected Error KTP Upload',
      action: getJsonStringify(err.response),
      label: auth.phoneNo
    });
    sendException({ desc: getJsonStringify(err.response), fatal: true });
  }
};

const handleBadRequest = (dispatch, err, auth) => {
  const code = getChannelContextCode(err, 'channel-context');

  if (code === null) {
    handleUnexpected(dispatch, err, auth, 'contact-cs', true);
    dispatch(setEktpImg(''));
    return;
  }

  const errorMap = {
    211091: 'ktp_failed_15mins',
    211051: 'incorrect_ktp',
    LNINQ01: 'system'
  };

  if (errorMap[code]) {
    dispatch(setError(errorMap[code]));
  }
};

/**
 * to handle error resubmit ktp
 * @param {*} dispatch
 * @param {*} err
 * @param {*} auth
 * @returns
 */
export const handleErrorResubmitKtp = (dispatch, err, auth) => {
  dispatch(setHomePath('/continue-apply'));

  if (err.code === 'ERR_CANCELED') return;
  if (err.code === 'ERR_NETWORK') {
    dispatch(setError('connection'));
    return;
  }

  if (err.response?.status === 400) {
    handleBadRequest(dispatch, err, auth);
  } else {
    handleUnexpected(dispatch, err, auth);
  }
};
